import { getAxiosErrorDisplayMessage } from '@/utils/error-utils';

// Tool ValidationErrors arrive with their field-level reasons folded into the message; the page
// shows exactly those words and never rewrites them.
export function toolErrorText(error: unknown): string {
  return getAxiosErrorDisplayMessage(error, 'The action failed.');
}
